import React from "react";
// import dayjs from "dayjs";
import "../PrintAudit.style.css";
import dayjs from "dayjs";

const AuditDetailsSection = ({ Details }) => {
  const {
    startDate,
    endDate,
    auditTypeCategoryName,
    auditTypeName,
    branchName,
    departmentName,
    areaName,
    auditId,
    auditorName,
    auditeeName,
    createdByName,
    // phoneNumberCountryCode,
  } = Details;
  // console.log("Details: ", Details);
  // const authUser = JSON.parse(
  //   localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
  // );

  return (
    <div className="permit-table-container">
      <table className="permit-table">
        <thead>
          <tr>
            <th>Id: {auditId}</th>
            <th>Category: {auditTypeCategoryName}</th>
            <th>Type: {auditTypeName}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Branch :</strong> {branchName || "Not Available"}
            </td>
            <td>
              <strong>Department :</strong> {departmentName || "Not Available"}
            </td>
            <td>
              <strong>Area:</strong> {areaName || "Not Available"}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Start Date:</strong>{" "}
              {dayjs(startDate).format("DD MMM YYYY") || "Not Available"}
            </td>
            <td>
              <strong>End Date:</strong>{" "}
              {dayjs(endDate).format("DD MMM YYYY") || "Not Available"}
            </td>
            <td>
              <strong>Created By:</strong> {createdByName || "Not Available"}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Auditor:</strong> {auditorName || "Not Available"}
            </td>
            <td>
              <strong>Auditee:</strong> {auditeeName || "Not Available"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AuditDetailsSection;
